export default "__VITE_ASSET__BrGHMe_Z__"